import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'a[app-nav-list-item]',
  standalone: true,
  templateUrl: './nav-list-item.component.html',
  styleUrl: './nav-list-item.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  host: {
    class: 'nav-list-item',
  },
})
export class NavListItemComponent {}
